import React, { useState, useEffect } from 'react';
import {
  Container,
  Typography,
  Paper,
  Button,
  Box,
  TextField,
  IconButton,
  Card,
  Modal,
  CircularProgress,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  InputAdornment
} from '@mui/material';
import { Close as CloseIcon, Delete, Edit, Star, StarBorder } from '@mui/icons-material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import { AttachFile } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios';
import { useSnackbar } from '../SnackbarContext';
import FileUpload from './FileUpload';
import PDF from '../../assets/Images/PDF.svg';
import GlobalVariable from "../../services/Global";

const baseApiUrl = GlobalVariable.BASE_API_URL;


const CustomToolbar = ({ handleAttachFileClick }) => (
  <div id="toolbar">
    <select className="ql-font">
      <option value="sans-serif" selected>
        Sans Serif
      </option>
      <option value="serif">Serif</option>
      <option value="monospace">Monospace</option>
    </select>
    <select className="ql-header">
      <option value="1">Heading 1</option>
      <option value="2">Heading 2</option>
      <option value="">Normal</option>
    </select>
    <button className="ql-bold"></button>
    <button className="ql-italic"></button>
    <button className="ql-underline"></button>
    <button className="ql-strike"></button>
    <button className="ql-list" value="ordered"></button>
    <button className="ql-list" value="bullet"></button>
    <select className="ql-align"></select>
    <button className="ql-link"></button>
    <button className="ql-image"></button>
    <button onClick={handleAttachFileClick}>
      <AttachFile style={{ fontSize: 18 }} />
    </button>
  </div>
);


const modules = {
  toolbar: {
    container: '#toolbar',
  },
};

const formats = [
  'font',
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'align',
  'link',
  'image',
];
const sections = [
  { value: "Cover Page", label: "Cover Page" },
  { value: "Cover Letter", label: "Cover Letter" },
  { value: "Proposal Contents Page", label: "Proposal Contents Page" },
  { value: "Brief Company Introduction", label: "Brief Company Introduction" },
  { value: "Company History and Mission", label: "Company History and Mission" },
  { value: "Company IT Staffing Experience", label: "Company IT Staffing Experience" },
  { value: "Technical Expertise", label: "Technical Expertise" },
  { value: "Past Performance", label: "Past Performance" },
  { value: "Pricing Details", label: "Pricing Details" },
  { value: "References", label: "References" },
];


const AddNewSection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showSnackbar } = useSnackbar();
  const [sectionName, setSectionName] = useState('');
  const [description, setDescription] = useState('');
  const [comment, setComment] = useState('');
  const [rating, setRating] = useState(0);
  const [documentType, setDocumentType] = useState('');
  const [openDialog, setOpenDialog] = useState(false);
  const [fileBase64, setFileBase64] = useState('');
  const [fileName, setFileName] = useState('');
  const [isPdfOpen, setPdfOpen] = useState(false);
  const [errors, setErrors] = useState({ sectionName: '', description: '', documentType: '' });
  const [loading, setLoading] = useState(false);
  const [responseSource, setResponseSource] = useState(false); 


  const validate = () => {
    let isValid = true;
    const newErrors = { sectionName: '', description: '', documentType: '' };

    if (!sectionName.trim()) {
      newErrors.sectionName = 'Section Name is required';
      isValid = false;
    } else if (sectionName.length < 3) {
      newErrors.sectionName = 'Section Name must be at least 3 characters long';
      isValid = false;
    }

    if (!description.trim()) {
      newErrors.description = 'Description is required';
      isValid = false;
    } else if (description.length < 10) {
      newErrors.description = 'Description must be at least 10 characters long';
      isValid = false;
    }

    if (!documentType.trim()) {
      newErrors.documentType = 'Document Type is required';
      isValid = false;
    }

    setErrors(newErrors);
    return isValid;
  };


  const handleSave = async () => {
    if (!validate()) return;
    const userdetails =JSON.parse(localStorage.getItem('userDetails'))
    const userId = userdetails.userDetails.id;
  
    setLoading(true);
    try {
      const requestData = {
        user_id: userId,
        content_name: sectionName,
        content_description: description,
        comment: comment,
        content_file: fileBase64,
        content_filename: fileName,
        star_rating: rating,
        rfp_type: documentType,
        toggle: !responseSource ? 'On' : 'Off',
      };

      const response = await axios.post(`${baseApiUrl}/contentlibrary/addclsection`,
        requestData,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 200) {
        showSnackbar('Section added successfully!');
        navigate('/content-library');
        setLoading(false);
      }
    } catch (error) {
      console.error('Error adding section:', error);
      showSnackbar('Error adding section. Please try again.', 'error');
      setLoading(false);
    }
  };

  const handleAttachFileClick = () => {
    setOpenDialog(true);
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  const handleSectionNameChange = (e) => {
    setSectionName(e.target.value);
    if (errors.sectionName) {
      setErrors((prevErrors) => ({ ...prevErrors, sectionName: '' }));
    }
  };

  const handleDescriptionChange = (value) => {
    setDescription(value);
    if (errors.description) {
      setErrors((prevErrors) => ({ ...prevErrors, description: '' }));
    }
  };
  const handleDeleteAttachment = () => {
    setFileBase64('');
    setFileName('');
  };

  const togglePdfView = () => {
    setPdfOpen(!isPdfOpen);
  };


  return (
    <Container fluid className="rfpDtailsContainer" maxWidth="100%" sx={{ padding: { xs: 1, sm: 2, md: 3 } }}>
      <Box mt={2}>
        <Paper elevation={3} sx={{ padding: { xs: 2, sm: 3, md: 5 }, borderRadius: '15px', width: '100%' }}>
          {loading && (
            <Box
              className="circular-progress"
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                zIndex: 1000,
              }}
            >
              <CircularProgress className=" text-primary" />
            </Box>
          )}
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h4">
              <strong>Add New Section</strong>
            </Typography>
            <Button
              variant="outlined"
              className="border-primary text-primary text-capitalize rounded-3"
              onClick={() => navigate(-1)}
            >
              Back
            </Button>
          </Box>
          <Box mt={2}>
            <Box display="flex" gap={3} flexDirection={{ xs: 'column', sm: 'column', md: 'row' }} alignItems="flex-start">
              <Box sx={{ width: { xs: '100%', md: '300px' } }}>
                <FormControl fullWidth margin="normal" className="inputfields">
              <Typography variant="h6">
                <strong>Section Name</strong>
              </Typography>
              <Select
                value={sectionName || ''}
                onChange={handleSectionNameChange}
                name="sectionName"
                IconComponent={KeyboardArrowDownIcon}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: "10px",
                    height: "45px",
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0, 0, 0, 0.23) !important",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "rgba(0, 0, 0, 0.23) !important",
                      borderWidth: "1px !important",
                    },
                    "&.Mui-focused": {
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23) !important",
                        borderWidth: "1px !important",
                      },
                    },
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderRadius: "10px",
                    height: "45px",
                    borderColor: "rgba(0, 0, 0, 0.23) !important",
                  },
                  "& .MuiSelect-icon": {
                    top: "8px",
                    color: "#000000",
                  },
                  "& .MuiOutlinedInput-input": {
                    paddingTop: "9px",
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      marginTop: '6px',
                      borderRadius: '10px',
                    },
                  },
                }}
                error={!!errors.sectionName}
              >
                {sections.map((section) => (
                  <MenuItem key={section.value} value={section.value}>
                    {section.label}
                  </MenuItem>
                ))}
              </Select>
              {errors.sectionName && (
                <Typography color="error" variant="body2" sx={{ mt: 0.5 }}>
                  {errors.sectionName}
                </Typography>
              )}
              



                </FormControl>
              </Box>
              <Box sx={{ width: { xs: '100%', md: '300px' } }}>
                <FormControl fullWidth margin="normal" className="inputfields">
              <Typography variant="h6">
                <strong>Document Type</strong>
              </Typography>
              <Box sx={{ position: 'relative', width: '100%' }}>
                <Select
                  value={documentType || ''}
                  onChange={(e) => {
                    setDocumentType(e.target.value);
                    if (errors.documentType) {
                      setErrors((prevErrors) => ({ ...prevErrors, documentType: '' }));
                    }
                  }}
                  name="documentType"
                  IconComponent={documentType ? () => null : KeyboardArrowDownIcon}
                  sx={{
                    width: '100%',
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "10px",
                      height: "45px",
                      "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23) !important",
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        borderColor: "rgba(0, 0, 0, 0.23) !important",
                      },
                      "&.Mui-focused": {
                        "& .MuiOutlinedInput-notchedOutline": {
                          borderColor: "rgba(0, 0, 0, 0.23) !important",
                        },
                      },
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderRadius: "10px",
                      height: "45px",
                      borderColor: "rgba(0, 0, 0, 0.23) !important",
                    },
                    "& .MuiSelect-icon": {
                      top: "8px",
                      color: "#000000",
                    },
                    "& .MuiOutlinedInput-input": {
                      paddingTop: "9px",
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        marginTop: '6px',
                        borderRadius: '10px',
                      },
                    },
                  }}
                  error={!!errors.documentType}
                >
                  <MenuItem value="staffing">Staffing</MenuItem>
                  <MenuItem value="solutioning">Solutioning</MenuItem>
                </Select>
                {documentType && (
                  <IconButton
                    size="small"
                    onClick={() => setDocumentType('')}
                    sx={{
                      position: 'absolute',
                      right: '8px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 1
                    }}
                  >
                    <CloseIcon />
                  </IconButton>
                )}
              </Box>
              {errors.documentType && (
                <Typography color="error" variant="body2" sx={{ mt: 0.5 }}>
                  {errors.documentType}
                </Typography>
              )}
              



            </FormControl>
              </Box>
              
              <Box sx={{ width: { xs: '100%', md: '300px' } }}>
                <FormControl fullWidth margin="normal" className="inputfields">
                  <Typography variant="h6" sx={{ mb: 1.5 }}>
                    <strong>Response Source</strong>
                  </Typography>
                  <Box 
                    sx={{ 
                      display: 'flex', 
                      alignItems: 'center', 
                      gap: { xs: 0.75, sm: 1 },
                      mt: 1
                    }}
                  >
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontSize: { xs: '12px', sm: '14px' },
                        color: !responseSource ? '#0175FF' : '#666',
                        fontWeight: !responseSource ? 600 : 400,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      saved response
                    </Typography>
                    <Box
                      onClick={() => setResponseSource(!responseSource)}
                      sx={{
                        position: 'relative',
                        width: { xs: '36px', sm: '44px' },
                        height: { xs: '18px', sm: '22px' },
                        borderRadius: { xs: '9px', sm: '11px' },
                        backgroundColor: responseSource ? '#0175FF' : '#e0e0e0',
                        cursor: 'pointer',
                        transition: 'background-color 0.3s ease',
                        flexShrink: 0,
                        '&:hover': {
                          backgroundColor: responseSource ? '#0156cc' : '#d0d0d0',
                        }
                      }}
                    >
                      <Box
                        sx={{
                          position: 'absolute',
                          top: { xs: '2px', sm: '2px' },
                          left: responseSource 
                            ? { xs: '20px', sm: '24px' }
                            : { xs: '2px', sm: '2px' },
                          width: { xs: '14px', sm: '18px' },
                          height: { xs: '14px', sm: '18px' },
                          borderRadius: '50%',
                          backgroundColor: 'white',
                          transition: 'left 0.3s ease',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                        }}
                      />
                    </Box>
                    <Typography 
                      variant="body2" 
                      sx={{ 
                        fontSize: { xs: '12px', sm: '14px' },
                        color: responseSource ? '#0175FF' : '#666',
                        fontWeight: responseSource ? 600 : 400,
                        transition: 'all 0.3s ease'
                      }}
                    >
                      AI-generated
                    </Typography>
                  </Box>
                </FormControl>
              </Box>
              
            </Box>
          </Box>
          <Box>
            <Typography variant="h6">
              <strong>Rating</strong>
            </Typography>
            <Box display="flex" alignItems="center" mt={1}>
              {[1, 2, 3, 4, 5].map((star) => (
                <IconButton
                  key={star}
                  onClick={() => setRating(star)}
                  sx={{ 
                    padding: '4px',
                    '&:hover': {
                      backgroundColor: 'transparent'
                    }
                  }}
                >
                  {star <= rating ? (
                    <Star sx={{ color: '#FFD700', fontSize: 32 }} />
                  ) : (
                    <StarBorder sx={{ color: '#C0C0C0', fontSize: 32 }} />
                  )}
                </IconButton>
              ))}
            </Box>
          </Box>
          <Box mt={3}>
            <Typography variant="h6">
              <strong>Description</strong>
            </Typography>
          </Box>
          <Box>
            <CustomToolbar handleAttachFileClick={handleAttachFileClick} />
            <ReactQuill
              value={description}
              onChange={handleDescriptionChange}
              modules={modules}
              formats={formats}
              placeholder="Section Description"
              style={{ height: '150px', marginTop: '10px' }}
            />
            {errors.description && (
              <Typography color="error" variant="body2">
                {errors.description}
              </Typography>
            )}
          </Box>
          
          <Box mt={3}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              <strong>Comment</strong>
            </Typography>
            <TextField
              fullWidth
              multiline
              rows={4}
              placeholder="Add a comment..."
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                  "&:hover .MuiOutlinedInput-notchedOutline": {
                    borderColor: "rgba(0, 0, 0, 0.23)",
                  },
                },
              }}
            />
          </Box>
          
          <Box mt={3}>
            {fileBase64 ? (
              <Typography variant="h6">
                <strong>Attachment</strong>
              </Typography>
            ) : null}
          </Box>
          <Card sx={{ width: '200px', justifyItems: 'center' }} >
            {fileBase64 ? (
              <>

                <img src={PDF} alt="PDF Icon"
                  onClick={togglePdfView}
                  style={{ cursor: 'pointer', color: '#0175FF', paddingTop: 5 }} />
                <Typography
                  variant="body1"
                  onClick={togglePdfView}
                  style={{ cursor: 'pointer', color: '#0175FF' }}
                >
                  {fileName}
                </Typography>
                <Box display={'flex'} mt={2}>
                  <IconButton color="error">
                    <Delete
                      onClick={handleDeleteAttachment}
                      className='delete-icon'
                    />
                  </IconButton>
                </Box>
              </>
            ) : (
              <Typography variant="body1"></Typography>
            )}

          </Card>
          <Box mt={3} display="flex" justifyContent="flex-end" marginTop={6}>
            <Button variant="contained" className="bg-primary text-capitalize rounded-3" onClick={handleSave}>
              Save
            </Button>
          </Box>
        </Paper>
      </Box>
      <FileUpload open={openDialog} onClose={handleDialogClose} setFileName={setFileName} setFileBase64={setFileBase64} />
      <Modal open={isPdfOpen} onClose={togglePdfView}>
        <Box
          width="80%"
          height="80%"
          margin="auto"
          bgcolor="white"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          mt="5%"
          p={2}
        >
          <CloseIcon onClick={togglePdfView} style={{ alignSelf: 'flex-end', cursor: 'pointer' }} />
          {fileBase64 && (
            <iframe
              src={fileBase64}
              width="100%"
              height="100%"
              title="PDF Viewer"
              style={{ border: 'none' }}
            />
          )}
        </Box>
      </Modal>
    </Container>
  );
};

export default AddNewSection;
